import { render, staticRenderFns } from "./ApprovalImageGallery.vue?vue&type=template&id=ac905ce6&"
import script from "./ApprovalImageGallery.vue?vue&type=script&lang=js&"
export * from "./ApprovalImageGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports